



export abstract class BaseItem<T> {
    id: any;
    is_new?: boolean;
    modified: Date;
    created: Date;
    owner_uid: any;
    modified_uid: any;
    archived: any;
}
export class Profile {
    uid: any;
    account_id: any;
    display_name: string;
    profile_url: string;
    email: string;
    token: any;
}

export enum PodCastFeedStatus {
    dirty = 'dirty',
    ready = 'ready',
    sync = 'sync',
    error = 'error',
    pendingSync = 'pendingSync'
}
export enum PodCastType {
    adhoc = 'adhoc',
    rss = 'rss'
}
export enum TrackDelivery {
    instant = "instant",
    ondemand = "ondemand"
}
export class PodCast extends BaseItem<PodCast> {
    title: string;
    last_error?: string;
    sub_title: string;
    descrition: string;
    url: string;
    image_url: string;
    author: string;
    categories: any;
    private: boolean;
    feed_url: string;
    feed_status: PodCastFeedStatus = PodCastFeedStatus.dirty;
    rss_url: string;
    podcast_type: PodCastType = PodCastType.adhoc;
    default_track_delivery: TrackDelivery = TrackDelivery.instant;
}
export class PodCastCatgory {
    id: any;

    parent_category_id?: any;
    display_name: string;

    static getCategories(): Array<PodCastCatgory> {
        /*
                let categories = [
                    {
                        "Arts": [
                            "Design",
                            "Fashion & Beauty",
                            "Food",
                            "Literature",
                            "Performing Arts",
                            "Visual Arts"
                        ]
                    },
                    {
                        "Business": [
                            "Business News",
                            "Careers",
                            "Investing",
                            "Management & Marketing",
                            "Shopping"
                        ]
                    },
                    { "Comedy": [] },
                    {
                        "Education": [
                            "Educational Technology",
                            "Higher Education",
                            "K-12",
                            "Language Courses",
                            "Training"
                        ]
                    },
                    {
                        "Games & Hobbies": [
                            "Automotive",
                            "Aviation",
                            "Hobbies",
                            "Other Games",
                            "Video Games"
                        ]
                    },
                    {
                        "Government & Organizations": [
                            "Local",
                            "National",
                            "Non-Profit",
                            "Regional"
                        ]
                    },
                    {
                        "Health": [
                            "Alternative Health",
                            "Fitness & Nutrition",
                            "Self-Help",
                            "Sexuality"
                        ]
                    },
                    { "Kids & Family": [] },
                    { "Music": [] },
                    { "News & Politics": [] },
                    {
                        "Religion & Spirituality": [
                            "Buddhism",
                            "Christianity",
                            "Hinduism",
                            "Islam",
                            "Judaism",
                            "Other",
                            "Spirituality"
                        ]
                    },
                    {
                        "Science & Medicine": [
                            "Medicine",
                            "Natural Sciences",
                            "Social Sciences"
                        ]
                    },
                    {
                        "Society & Culture": [
                            "History",
                            "Personal Journals",
                            "Philosophy",
                            "Places & Travel"
                        ]
                    },
                    {
                        "Sports & Recreation": [
                            "Amateur",
                            "College & High School",
                            "Outdoor",
                            "Professional"
                        ]
                    },
                    {
                        "Technology": [
                            "Gadgets",
                            "Tech News",
                            "Podcasting",
                            "Software How-To"
                        ]
                    },
                    { "TV & Film": [] },
                ]
        
                let index = 1;
                let retval = new Array<PodCastCatgory>()
                for (var i in categories) {
        
                    retval.push({
                        id: index.toString(),
                        display_name: Object.keys(categories[i])[0]
                    } as PodCastCatgory);
                    let subindex = 1;
        
        
                    for (var subcategory in categories[i][Object.keys(categories[i])[0]]) {
        
                        retval.push({
                            id: index.toString() + ':' + subindex,
                            parent_category_id: index.toString(),
                            display_name: categories[i][Object.keys(categories[i])[0]][subcategory]
                        } as PodCastCatgory);
                        subindex++;
                    }
                    index++;
        
                }
                return retval;*/
        return [{ "id": "1", "display_name": "Arts" }, { "id": "1:1", "parent_category_id": "1", "display_name": "Design" }, { "id": "1:2", "parent_category_id": "1", "display_name": "Fashion & Beauty" }, { "id": "1:3", "parent_category_id": "1", "display_name": "Food" }, { "id": "1:4", "parent_category_id": "1", "display_name": "Literature" }, { "id": "1:5", "parent_category_id": "1", "display_name": "Performing Arts" }, { "id": "1:6", "parent_category_id": "1", "display_name": "Visual Arts" }, { "id": "2", "display_name": "Business" }, { "id": "2:1", "parent_category_id": "2", "display_name": "Business News" }, { "id": "2:2", "parent_category_id": "2", "display_name": "Careers" }, { "id": "2:3", "parent_category_id": "2", "display_name": "Investing" }, { "id": "2:4", "parent_category_id": "2", "display_name": "Management & Marketing" }, { "id": "2:5", "parent_category_id": "2", "display_name": "Shopping" }, { "id": "3", "display_name": "Comedy" }, { "id": "4", "display_name": "Education" }, { "id": "4:1", "parent_category_id": "4", "display_name": "Educational Technology" }, { "id": "4:2", "parent_category_id": "4", "display_name": "Higher Education" }, { "id": "4:3", "parent_category_id": "4", "display_name": "K-12" }, { "id": "4:4", "parent_category_id": "4", "display_name": "Language Courses" }, { "id": "4:5", "parent_category_id": "4", "display_name": "Training" }, { "id": "5", "display_name": "Games & Hobbies" }, { "id": "5:1", "parent_category_id": "5", "display_name": "Automotive" }, { "id": "5:2", "parent_category_id": "5", "display_name": "Aviation" }, { "id": "5:3", "parent_category_id": "5", "display_name": "Hobbies" }, { "id": "5:4", "parent_category_id": "5", "display_name": "Other Games" }, { "id": "5:5", "parent_category_id": "5", "display_name": "Video Games" }, { "id": "6", "display_name": "Government & Organizations" }, { "id": "6:1", "parent_category_id": "6", "display_name": "Local" }, { "id": "6:2", "parent_category_id": "6", "display_name": "National" }, { "id": "6:3", "parent_category_id": "6", "display_name": "Non-Profit" }, { "id": "6:4", "parent_category_id": "6", "display_name": "Regional" }, { "id": "7", "display_name": "Health" }, { "id": "7:1", "parent_category_id": "7", "display_name": "Alternative Health" }, { "id": "7:2", "parent_category_id": "7", "display_name": "Fitness & Nutrition" }, { "id": "7:3", "parent_category_id": "7", "display_name": "Self-Help" }, { "id": "7:4", "parent_category_id": "7", "display_name": "Sexuality" }, { "id": "8", "display_name": "Kids & Family" }, { "id": "9", "display_name": "Music" }, { "id": "10", "display_name": "News & Politics" }, { "id": "11", "display_name": "Religion & Spirituality" }, { "id": "11:1", "parent_category_id": "11", "display_name": "Buddhism" }, { "id": "11:2", "parent_category_id": "11", "display_name": "Christianity" }, { "id": "11:3", "parent_category_id": "11", "display_name": "Hinduism" }, { "id": "11:4", "parent_category_id": "11", "display_name": "Islam" }, { "id": "11:5", "parent_category_id": "11", "display_name": "Judaism" }, { "id": "11:6", "parent_category_id": "11", "display_name": "Other" }, { "id": "11:7", "parent_category_id": "11", "display_name": "Spirituality" }, { "id": "12", "display_name": "Science & Medicine" }, { "id": "12:1", "parent_category_id": "12", "display_name": "Medicine" }, { "id": "12:2", "parent_category_id": "12", "display_name": "Natural Sciences" }, { "id": "12:3", "parent_category_id": "12", "display_name": "Social Sciences" }, { "id": "13", "display_name": "Society & Culture" }, { "id": "13:1", "parent_category_id": "13", "display_name": "History" }, { "id": "13:2", "parent_category_id": "13", "display_name": "Personal Journals" }, { "id": "13:3", "parent_category_id": "13", "display_name": "Philosophy" }, { "id": "13:4", "parent_category_id": "13", "display_name": "Places & Travel" }, { "id": "14", "display_name": "Sports & Recreation" }, { "id": "14:1", "parent_category_id": "14", "display_name": "Amateur" }, { "id": "14:2", "parent_category_id": "14", "display_name": "College & High School" }, { "id": "14:3", "parent_category_id": "14", "display_name": "Outdoor" }, { "id": "14:4", "parent_category_id": "14", "display_name": "Professional" }, { "id": "15", "display_name": "Technology" }, { "id": "15:1", "parent_category_id": "15", "display_name": "Gadgets" }, { "id": "15:2", "parent_category_id": "15", "display_name": "Tech News" }, { "id": "15:3", "parent_category_id": "15", "display_name": "Podcasting" }, { "id": "15:4", "parent_category_id": "15", "display_name": "Software How-To" }, { "id": "16", "display_name": "TV & Film" }]
    }
}

enum AudioType {
    mpeg = 'audio/mpeg'
}
let  getRandomInt = function(max:number):number {
    return Math.floor(Math.random() * Math.floor(max));
  }
export class Voices {
    name: string;
    language_code: string;
    male: boolean;
    premium: MediaVoice;
    normal: MediaVoice;
    static getVoices(): Array<Voices> {
        let retval = new Array<Voices>();
        retval.push(
            {
                name: "elizabeth",
                language_code: 'en-GB',
                male: false,
                premium: {
                    language_code: 'en-GB',
                    name: 'en-GB-Wavenet-A',
                    speaking_rate: 0.8,
                    male: false,
                    premium:true
                },
                normal: {
                    language_code: 'en-GB',
                    name: 'en-GB-Standard-A',
                    speaking_rate: 0.8,
                    male: false,
                    premium:false
                }
            }
        )
        retval.push( {
            name: "jack",
            male: true,
            language_code: 'en-GB',
            premium: {
                language_code: 'en-GB',
                name: 'en-GB-Wavenet-B',
                speaking_rate: 0.8,
                male: true,
                premium:true
            },
            normal: {
                language_code: 'en-GB',
                name: 'en-GB-Standard-B',
                speaking_rate: 0.8,
                male: true,
                premium:false
            }
        })
        
        retval.push( {
            name: "victoria",
            language_code: 'en-GB',
            male: false,
            premium: {
                language_code: 'en-GB',
                name: 'en-GB-Wavenet-C',
                speaking_rate: 0.8,
                male: false,
                premium:true
            },
            normal: {
                language_code: 'en-GB',
                name: 'en-GB-Standard-C',
                speaking_rate: 0.8,
                male: false,
                premium:false
            }
        })
        retval.push( {
            name: "charlie",
            language_code: 'en-GB',
            male:true,
            premium: {
                language_code: 'en-GB',
                name: 'en-GB-Wavenet-D',
                speaking_rate: 0.8,
                male: false,
                premium:true
            },
            normal: {
                language_code: 'en-GB',
                name: 'en-GB-Standard-D',
                speaking_rate: 0.8,
                male: false,
                premium:false
            }
        })
        return retval;
    }
    static getRandomIntro():string{
      // return "./audio-intro2.mp3"
      return "./audio-intro"+(getRandomInt(3)+1)+'.mp3'
    }
    static getRandomVoice(sex:number,ignoreVoiceName?:string,  ):Voices
    {   
       
       
        let voices = Voices.getVoices();
        let trys=50;
        debugger;
        while(trys>0)
        {
            let voice = voices[getRandomInt(voices.length)];
            if(voice.name != ignoreVoiceName && (sex == 0 || ((sex>0)==voice.male)))
            {
                
                return voice;
            }
            trys--;// Incase there is a bug and it blows up my hosting
        }
        return voices[0];
    }
}


export class MediaVoice {
    language_code: string;
    name: string;
    speaking_rate: number = 0.8;
    male: boolean;
    premium:boolean;
}


export class Media extends BaseItem<Media> {
    text_url: string;
    audio_url: string;
    size: number;
    duration: number;
    voice: MediaVoice = new MediaVoice();
    type: AudioType = AudioType.mpeg;
}
/*
enum TrackJobStatus {
    draft = 0,
    textExtraction = 1,
    confirmation = 2,
    payment = 3,
    processing = 4,
    completed = 5,
    onhold = 6

}
export class TrackJob extends BaseItem<TrackJob> {
    track_id: any;
    media_id: any;
    source_url: string;
    text_url: string;
    status: TrackJobStatus;
}*/

export enum TrackStatus {
    draft = 0,
    queued = 1,
    processing = 2,
    completed = 3,
    error = 4,
    ondemand = 5,
    pendingPayment = 6,
    prepareOnDemand = 7
}
export class Track extends BaseItem<Track> {
    title: string;
    soft_title: string;
    publish_date: Date;
    copyright: string;
    publisher: string;
    canonical_url: string;
    source_url: string;
    description: string;
    author: string;
    explicit: boolean;
    lang: string;
    image_url: string;
    duration: number;
    media: Media = new Media();
    podcast_id: any;
    parent_track_id?: any;
    status: TrackStatus;
    status_message: string;
    status_percentage: number = 0;

    transaction_id: any;
}
export class CreateTrackRequest {

    track: Track;
    text: string;
    skipJobCreation: boolean = false;
}



export enum TrackJobStatus { queued, running, done, error, archive };
export enum TrackJobType { convertToAudio, updateFeed }

export enum bgJobType {
    ConvertTrackTextToAudio = "ConvertTrackTextToAudio",
    UpdatePodCastFeed = "UpdatePodCastFeed"
}
export class bgConvertTrackTextToAudioPayload {
    track_id: any;
}
export class bgUpdatePodCastFeed {
    podcast_id: any;
}
export class BackgroundJob extends BaseItem<BackgroundJob> {
    payload: any;
    status: TrackJobStatus = TrackJobStatus.queued;
    error_message: any;

    type: bgJobType;

    static getPayload<T>(b: BackgroundJob): T {
        return b.payload as T;
    }
    static create(type: bgJobType, payload: any) {
        let newObj = new BackgroundJob();
        newObj.type = type;
        newObj.payload = payload;
        return newObj;
    }
    constructor() {
        super();


    }
}

export enum PlanCode{
    free = "FREE",
    trail = "TRIAL",
    pro = "PRO",
    premium="PREMIUM",
    admin="ADMIN"
}
export class CustomerPlan
{
    subscription_cost:number;
    subscription_cost_currency:string = "USD";
    subscription_interval:number;
    subscription_credits:number;
    credit_threshold:number;
    premium_credit_cost:number;
    normal_credit_cost:number;
    duplicate_credit_cost:number;
    premium_per_period:number;
    normal_per_period:number;
    duplicate_per_period:number;
    max_podcast:number;
    customize_voice:boolean;
    podcast_retention_days:number;
    plan_code:PlanCode;
    name:string;
}
export class CustomerBalance extends BaseItem<CustomerBalance> {
    credits: number;
    premiumForPeriod:number;
    normalForPeriod:number;
    duplicateForPeriod:number;
    startPeriod:Date;
    nextPeriod:Date;
    plan_code:any;
}
export class CustomerSettings extends BaseItem<CustomerSettings>{
    has_purchased_track: boolean = false;
    default_podcast_id: any = undefined;
}
export enum TransactionType {
    purchaseCredits = 'purchaseCredits',
    useCreditsOnTrack = 'useCreditsOnTrack',
    refund = 'refund',
    addCredit = 'addCreate',
    changePlanAdjustment="changePlanAdjustment"
}
export enum PurchaseType
{
    premium='premium',
    normal='normal',
    duplicate='duplicate'
}
export class Transaction extends BaseItem<Transaction>{
    transaction_type: TransactionType;
    track_id?: any;
    description: any;
    external_id: any;
    amount: number;
    amount_currency_code: string;
    credits: number;
    purchase_type:PurchaseType;
    log:Array<string>;
    meta: any;
}

export class ValidateRssFeedReponse {
    podcast: PodCast;
    tracks: Array<Track>;
}


// WEBPACK FOOTER //
// ./src/data/model.ts